export default __webpack_public_path__ + "static/media/example1.5f678d12.gif";